<div *ngIf="currentUser | async; else loggedOut">
  <app-dashboard></app-dashboard>
</div>
<ng-template #loggedOut>
  <app-home-landing></app-home-landing>
</ng-template>
